export const ABOUT_DETAILS_REQUEST = "ABOUT_DETAILS_REQUEST";
export const ABOUT_DETAILS_SUCCESS = "ABOUT_DETAILS_SUCCESS";
export const ABOUT_DETAILS_FAIL = "ABOUT_DETAILS_FAIL";

export const ABOUT_ADMIN_DETAILS_REQUEST = "ABOUT_ADMIN_DETAILS_REQUEST";
export const ABOUT_ADMIN_DETAILS_SUCCESS = "ABOUT_ADMIN_DETAILS_SUCCESS";
export const ABOUT_ADMIN_DETAILS_FAIL = "ABOUT_ADMIN_DETAILS_FAIL";

export const ABOUT_UPDATE_REQUEST = "ABOUT_UPDATE_REQUEST";
export const ABOUT_UPDATE_SUCCESS = "ABOUT_UPDATE_SUCCESS";
export const ABOUT_UPDATE_FAIL = "ABOUT_UPDATE_FAIL";
export const ABOUT_UPDATE_RESET = "ABOUT_UPDATE_RESET";

export const ABOUT_DELETE_REQUEST = "ABOUT_DELETE_REQUEST";
export const ABOUT_DELETE_SUCCESS = "ABOUT_DELETE_SUCCESS";
export const ABOUT_DELETE_FAIL = "ABOUT_DELETE_FAIL";
export const ABOUT_DELETE_RESET = "ABOUT_DELETE_RESET";
